export type CompactApiType<T extends { id: string; attributes: object }> = { id: string } & T['attributes']

export function compact<T extends { id: string; attributes: object }>(obj: T): CompactApiType<T> {
  return { id: obj.id, ...obj.attributes }
}
